export abstract class EventBody {
  gaClientId: string;
  userUrn: string;
  pageKey: string;
  clientTimestamp: number;
}
